module.exports = __webpack_public_path__ + "static/media/muffin.8e747489.svg";